import { connect } from 'react-redux';
import { default as IBASRoot } from './IBAS';
import { getUserInfo } from 'src/store/Dashboard/actions';
import { getTokenThunk } from 'src/store/Auth/actions';

const mapStateToProps = ({ dashboard }) => ({
  listings: dashboard.listings,
  benchmarkListings: dashboard.benchmarkListings,
  graph: dashboard.graph,
  statsPerADR: dashboard.statsPerADR,
  reviewStream: dashboard.reviewStream,
  search: dashboard.search,
  filter: dashboard.filter,
});

export const IBAS = connect(mapStateToProps, {
  getTokenThunk,
  getUserInfo,
})(IBASRoot);
